// import "./style.css";

import { withStyles } from '@material-ui/core';
import cx from 'classnames';
import Moment from 'moment';
import React from 'react';
import DateLabel from '../../general/date/date-label';
import Hint from '../hint';
import DraftFormula from './draft-formula';
import Formula from './formula';
import styles from './styles';

const stringBlackList = ['', 'null'];
const dateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}).(\d{7})/;

class ReadOnly extends React.Component {
  static defaultProps = {
    hint: '',
    inline: false,
    size: 'Auto-Size'
  };

  get className() {
    const { classes, className, size, text } = this.props;

    return cx(className, classes[size], { [classes.blue]: !!text });
  }

  render() {
    let m, val;
    const { classes, hint = '', forceNotSpecified, text, value } = this.props;

    if (value) {
      m = new Moment(new Date(value)).clone();
    }

    if (this.props.formula) {
      val = <DraftFormula {...this.props} />;
    } else if (React.isValidElement(value)) {
      val = value;
      if (forceNotSpecified) {
        val = null;
      }
    } else if (this.props.isDate === true && (value instanceof Date || (m && m.isValid()))) {
      val = <DateLabel value={m.toDate()} skipUtc={true} />;
    } else if (value instanceof Date && m && m.isValid()) {
      val = <DateLabel value={m.toDate()} skipUtc={true} />;
    } else if (typeof value === 'string') {
      if (value != null && value.match(dateRegex)) {
        val = <DateLabel value={m.toDate()} skipUtc={true} />;
      } else {
        val = stringBlackList.includes(value.trim()) ? null : value;
      }
    }

    if (text) {
      if (val)
        val = (
          <span>
            {text + ': '}
            {val}
          </span>
        );
      else val = text;
    }

    let control;
    if (val === null) {
      control = <span className={classes.unspecified}>Not Specified</span>;
    } else {
      control = <span className={this.className}>{val}</span>;
    }

    return (
      <span style={this.props.style}>
        {hint ? <Hint hint={hint} /> : null}
        {!this.props.inline && this.props.label != null && !this.props.hideLabel ? (
          <div className={classes.label} style={this.props.labelStyle}>
            {this.props.label}
          </div>
        ) : undefined}
        <span className={classes.readonly}>{control}</span>
      </span>
    );
  }
}

export default withStyles(styles)(ReadOnly);
